import AppRouter from 'router'
import {LayoutProvider} from 'layout/core'
import {
  ToastContainer,
  // toast
} from 'react-toastify'
import {useEffect} from 'react'
import {parseError} from 'utils'
import {useDispatch} from 'react-redux'
import {getSocieties} from 'services/api/actions'
import {updateSocieties} from 'store/actions/configs'

function App() {
  const dispatch = useDispatch()

  const getSocietiesList = () => {
    getSocieties()
      .then((response) => {
        dispatch(updateSocieties(response.data ?? []))
      })
      .catch((error) => {
        console.log(parseError(error))
      })
  }

  useEffect(() => {
    getSocietiesList()
  }, [])

  return (
    <>
      <ToastContainer
        autoClose={4000}
        draggable={false}
        position='top-right'
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnHover
      />

      <LayoutProvider>
        <AppRouter />
      </LayoutProvider>
    </>
  )
}

export default App
